(function () {
  var START = (20 * 3600 + 39 * 60) * 1000, KEY = 'ap_bf_end';
  function end() {
    var e = 0;
    try { e = Number(localStorage.getItem(KEY)) || 0; } catch (x) {}
    if (!e || e < Date.now()) { e = Date.now() + START; try { localStorage.setItem(KEY, String(e)); } catch (x) {} }
    return e;
  }
  var e = end();
  function tick() {
    var left = e - Date.now();
    if (left <= 0) { e = end(); left = e - Date.now(); }
    var s = Math.floor(left / 1000), v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
    document.querySelectorAll('[data-bf-timer]').forEach(function (box) {
      box.querySelectorAll('.countdown-timer__number').forEach(function (n, i) { n.textContent = String(v[i] || 0).padStart(2, '0'); });
    });
  }
  tick(); setInterval(tick, 1000);
})();
